import type { TrackingProperties } from '@change-corgi/tracking-properties';

type Momentum = Readonly<{ tier: 'SPIKING' | 'SURGING' }> | null | undefined;

export function getSpikeTier(momentum: Momentum): NonNullable<TrackingProperties['spike_tier']> {
	if (!momentum) return 'none';
	return momentum.tier === 'SURGING' ? 'surging' : 'spiking';
}
